import React from "react";
import { Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { AuthModals } from "../config/const";
import useAuthModalHook from "../hooks/useAuthModalHook";

import Close from "../assets/images/icons/arrow-next_back.svg";
import Sportsbook from "../assets/images/icons/head-menu/sports.svg";
import Exchange from "../assets/images/icons/head-menu/sports.svg";
import LiveCasino from "../assets/images/icons/head-menu/live-casino.svg";
import Casino from "../assets/images/icons/head-menu/casino.svg";
import Promotion from "../assets/images/icons/head-menu/promotion.svg";
import APK from "../assets/images/downloadApp.png";

export default function LeftMenuBar({ show, onClose }) {
  const { isAuth } = useSelector((state) => state.auth);
  const { updateActiveAuthModal } = useAuthModalHook();
  const { appDetails } = useSelector((state) => state.app);
  const location = useLocation();
  const pathname = location.pathname;

  const navItems = [
    { href: "/sportsbook", label: "Sportsbook", icon: Sportsbook },
    { href: "/sports/Cricket", label: "Exchange", icon: Exchange },
    { href: "/live-casino", label: "Live Casino", icon: LiveCasino },
    { href: "/casino", label: "Virtual Casino", icon: Casino },
    { href: "/promotion", label: "Promotion", icon: Promotion },
  ];

  return (
    <>
      <div className={`leftbar-menu d-lg-none ${show ? "open" : ""}`}>
        <Button className="close" onClick={onClose}>
          <img src={Close} alt="close leftbar" />
        </Button>

        <div className="side-logo">
          <a href="/home">
            <img src={appDetails?.LOGO_URL} alt="Logo" />
          </a>
        </div>

        <ul className="menu-list">
          {navItems.map((item, index) => (
            <li key={index}>
              <a
                href={item.href}
                className={pathname === item.href ? "active" : ""}
              >
                <img src={item.icon} alt={item.label} />
                <span>{item.label}</span>
              </a>
            </li>
          ))}
        </ul>

        {!isAuth ? (
          <div className="login-signup">
            <Button
              variant="primary"
              onClick={() => {
                // navigate("/sign-in");
                updateActiveAuthModal(AuthModals.Login);
              }}
              className="button-primary btn_signin my-3"
            >
              Login
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                // navigate("/mobile-number");
                updateActiveAuthModal(AuthModals.MobileNumber);
              }}
              className="button-primary btn_signup my-2"
            >
              Join Now
            </Button>

            <a
              href="https://dl.dropbox.com/scl/fi/cg2e1je1c91795b43bdya/Prada365.apk?rlkey=9o6q84wpi7jwlvjxa8vjxc2xp&st=nud6p5xw&dl=0"
              download="https://dl.dropbox.com/scl/fi/cg2e1je1c91795b43bdya/Prada365.apk?rlkey=9o6q84wpi7jwlvjxa8vjxc2xp&st=nud6p5xw&dl=0"
            >
              <img src={APK} alt="download app" />
            </a>
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
}
